import React, { FC, useEffect } from "react";

import { Box, Button, SelectChangeEvent } from "@mui/material";
import {
  DataGridPro,
  GridEventListener,
  GridRowEditStopReasons,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import { ThemeProvider } from "@mui/material/styles";

import themeInarix from "../../../StylesMuiInarix";

import { useTranslation } from "react-i18next";
import { State } from "../../../../redux/slices";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import {
  resetStateCreateUsers,
  setCreateUsersStep,
  setColumns,
  setRowsAlpha,
  CreateUsersStep,
  setMaximumNumberFromUserCreations,
  setUserConfigRows,
  setCreateUsers,
  initialState,
} from "../../../../redux/slices/users/createUsers";
import AddIcon from "@mui/icons-material/Add";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { createMultiUsersWithActions } from "../../../../redux/actions/locations/locationsAsyncActions";
import { TokenPayload } from "../../../../redux/actions/authentication/authentication";
import jwt from "jsonwebtoken";
import Alert from "@mui/material/Alert";
import CreateLocationsColumnsRows from "../../../userLocations/steps/stepConfigUsers/FetchColumnsConfig";
import { MenuCreateUsers } from "../MainCreateUsers";
import { infoValidator } from "../managerUsers/managerUsersPartsOfTable/UsersManagersConfigTable";
import { setTryToCreate } from "../../../../redux/slices/location/createLocation";
import { SiteUsersConfigRows } from "../../../../redux/actions/users/userTypes";
import { selectLocale } from "../../../../redux/slices/layout";
import { CheckExpiredToken } from "../../../../utils/authentication";
import { SetActionsLayout } from "../../../layout/Layout";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    setRowsAlpha2: (value: SiteUsersConfigRows[]) => {
      dispatch(setRowsAlpha(value));
    },
    setConfigRow: (value: SiteUsersConfigRows[]) => {
      dispatch(setUserConfigRows(value));
    },
    setSteps: (value: CreateUsersStep) => {
      dispatch(setCreateUsersStep(value));
    },
    cancel: () => {
      dispatch(resetStateCreateUsers());
    },
    setColumnIndex: (columns: any) => {
      dispatch(setColumns(columns));
    },

    setStep: (value: CreateUsersStep) => {
      dispatch(setCreateUsersStep(value));
    },

    creatMultiUsers: (adminId: string, token: string, realmId: number) => {
      dispatch(createMultiUsersWithActions({ adminId, token, realmId }));
    },

    resetCreateUsersValues: () => {
      dispatch(setCreateUsers(initialState.createUsers));
    },

    setMaximumNumber: (value: number, removedUsernames: number) => {
      if (removedUsernames >= 1) {
        return () => {};
      } else {
        dispatch(setMaximumNumberFromUserCreations(value));
      }
    },

    tryToCreate: (value: boolean) => {
      dispatch(setTryToCreate(value));
    },
  };
};

export const StepConfigCreateUsersFromUsers: FC<any> = () => {
  const apiRef = useGridApiRef();
  const [t] = useTranslation("global");
  const { user, companyName } = useSelector(
    (state: State) => state.Authentication
  );
  const navigate = useNavigate();

  const {
    setSteps,
    cancel,
    setColumnIndex,
    setRowsAlpha2,
    creatMultiUsers,
    setMaximumNumber,
    setConfigRow,
    tryToCreate,
    resetCreateUsersValues,
  } = SetActions();
  const { logoutClickHandler } = SetActionsLayout();

  const {
    createUserSteps,
    usersConfigRows,
    columns,
    rowsAlpha,
    errorCreateLocations,
    errorCreateUsers,
    createUsers,
    theMaximumNumberIntheUsernamesCreations,
    verifyIfAllIsCreated,
  } = useSelector((state: State) => state.CreateUsersReducer);

  const { tryToCreateSomething, multiLocationLoading } = useSelector(
    (state: State) => state.CreateLocationReducer
  );
  const locale = useSelector(selectLocale);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>(
    {}
  );
  const companyNameUsers = companyName ?? "error";
  const token = user?.token ?? "";
  const { userId, realmId }: TokenPayload = jwt.decode(token) as TokenPayload;

  const r = usersConfigRows?.filter(
    (elem) => !rowsAlpha.find(({ username }) => elem.username === username)
  );

  const removedUsernames = r.map((values) => values.username);

  const managingUserNames = () => {
    if (removedUsernames.length >= 1) {
      return removedUsernames[0];
    } else {
      return `${companyNameUsers}-${
        theMaximumNumberIntheUsernamesCreations + 1
      }`;
    }
  };

  const handleRowEditStop: GridEventListener<"rowEditStop"> = (
    params,
    event
  ) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id: GridRowId) => () => {
    setRowsAlpha2(rowsAlpha.filter((row) => row.id !== id));
  };
  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rowsAlpha.find((row) => row.id === id);
    if (editedRow!.isNew) {
      setRowsAlpha2(rowsAlpha.filter((row) => row.id !== id));
    }
  };

  const toggleNomad = (id: GridRowId) => () => {
    setRowsAlpha2(
      rowsAlpha.map((row) =>
        row.id === id
          ? ({
              ...row,
              nomadUser: !row.nomadUser,
              assignedSite: !row.nomadUser
                ? { name: "Nomad", id: "nomad" }
                : { name: t("Common_options.select"), id: "select" },
            } as SiteUsersConfigRows)
          : row
      )
    );
  };

  const handleChange = (
    locationID: string,
    locationName: string,
    id: number
  ) => {
    setRowsAlpha2(
      rowsAlpha.map((row) =>
        row.id === id
          ? {
              ...row,
              assignedSite: {
                name: locationName,
                id: locationID,
              },
              nomadUser: false,
            }
          : row
      )
    );
  };

  const handleChangeActions = (event: SelectChangeEvent<any>, id: number) => {
    const {
      target: { value },
    } = event;

    setRowsAlpha2(
      rowsAlpha.map((row) =>
        row.id === id
          ? {
              ...row,
              assignedAction: value === "string" ? value.split(",") : value,
            }
          : row
      )
    );
  };

  const handleChangeUsername = (event: any, id: GridRowId) => {
    const {
      target: { value },
    } = event;

    setRowsAlpha2(
      rowsAlpha.map((row: any) =>
        row.id === id
          ? {
              ...row,
              username: value === "string" ? value.split(",") : value,
            }
          : row
      )
    );
  };

  const processRowUpdate = (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    setRowsAlpha2(
      rowsAlpha.map((row) =>
        row.id === newRow.id ? updatedRow : row
      ) as SiteUsersConfigRows[]
    );
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const { rawColumns } = CreateLocationsColumnsRows(
    columns,
    rowModesModel,
    handleSaveClick,
    handleCancelClick,
    handleEditClick,
    handleDeleteClick,
    handleChangeUsername,
    toggleNomad,
    handleChange,
    handleChangeActions,
    usersConfigRows
  );

  if (createUsers.numberOfUserToCreate === 0) {
    navigate("/create-users");
  }

  useEffect(() => {
    tryToCreate(false);
    if (rowsAlpha.length === 0) {
      setRowsAlpha2(usersConfigRows);
    }
    CheckExpiredToken(logoutClickHandler, user);
    setSteps({ ...createUserSteps, place: "configs" });
  }, []);

  const editToolbar = () => {
    const handleClick = () => {
      const id = Math.random();
      setMaximumNumber(
        theMaximumNumberIntheUsernamesCreations + 1,
        removedUsernames.length
      );

      setConfigRow([
        ...usersConfigRows,
        {
          id,
          username: managingUserNames(),
          assignedSite: { name: t("Common_options.select"), id: "select" },
          assignedAction: [],
          nomadUser: false,
          isNew: true,
        },
      ]);

      setRowsAlpha2([
        ...rowsAlpha,
        {
          id,
          username: managingUserNames(),
          assignedSite: { name: t("Common_options.select"), id: "select" },
          assignedAction: [],
          nomadUser: false,
          isNew: true,
        },
      ]);

      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "username" },
      }));
    };

    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          disabled={rowsAlpha.length >= 100 || multiLocationLoading}
          onClick={handleClick}
        >
          {t("Create_site.config_users.add_user")}
        </Button>
      </GridToolbarContainer>
    );
  };

  const managingError = () => {
    if (errorCreateLocations) {
      return (
        <Alert severity="error">{JSON.stringify(errorCreateLocations)}</Alert>
      );
    }
    if (errorCreateUsers) {
      return <Alert severity="error">{JSON.stringify(errorCreateUsers)}</Alert>;
    }

    if (!errorCreateLocations && !errorCreateUsers) {
      return "";
    }
  };

  const siteValidator = (name: string | undefined) => {
    if (name === undefined || name === "") {
      return false;
    }
  };

  const theUserIsGood = () => {
    const transformToValidate = rowsAlpha.map((validateRows, index) => ({
      username: validateRows.username,
      assignedSite: validateRows.assignedSite,
      assignedAction: validateRows.assignedAction,
      nomadUser: validateRows.nomadUser,
      isTheAssignedSiteGood: siteValidator(
        validateRows?.assignedSite?.name
          ? validateRows?.assignedSite?.name
          : undefined
      ),
      isTheassignedActionGood: !infoValidator(validateRows.assignedAction),
      rowPosition: index + 1,
    }));
    return transformToValidate;
  };

  const encounterErrorSites = theUserIsGood().filter(
    (rows) => rows.isTheAssignedSiteGood === false
  );

  const encounterErrorActions = theUserIsGood().filter(
    (rows) => rows.isTheassignedActionGood === false
  );

  const totalErrors = encounterErrorSites?.concat(encounterErrorActions).length;

  const managingErrorValidator = () => {
    const assignedSiteError = () => {
      const resultsAssignedSitesErrors = encounterErrorSites.map((results) => (
        <span className="mr-2">
          {encounterErrorSites.length === 1
            ? `${results.rowPosition}`
            : `${results.rowPosition},`}
        </span>
      ));

      return (
        <div>
          {resultsAssignedSitesErrors.length >= 1 ? (
            <div>
              <span className="mr-2">
                {t("Users_managers.not_assigned_sites")}
              </span>
              <span>{`${t("Users_managers.line")} : `}</span>
              {resultsAssignedSitesErrors}
            </div>
          ) : (
            ""
          )}
        </div>
      );
    };

    const assignedActionError = () => {
      const resultsAssignedActionsErrors = encounterErrorActions.map(
        (results) => (
          <span className="mr-2">
            {encounterErrorActions.length === 1
              ? `${results.rowPosition}`
              : `${results.rowPosition},`}
          </span>
        )
      );

      return (
        <div>
          {resultsAssignedActionsErrors.length >= 1 ? (
            <div>
              <span className="mr-2">
                {t("Users_managers.not_assigned_actions")}
              </span>

              <span>
                {resultsAssignedActionsErrors.length === 1
                  ? t("Users_managers.line")
                  : `${t("Users_managers.line")} : `}
              </span>
              {resultsAssignedActionsErrors}
            </div>
          ) : (
            ""
          )}
        </div>
      );
    };

    return (
      <Alert severity="error">
        {tryToCreateSomething ? (
          <div>
            <div>{assignedSiteError()}</div>
            <div>{assignedActionError()}</div>
          </div>
        ) : (
          ""
        )}
      </Alert>
    );
  };

  const managingShowErrors = () => {
    if (totalErrors >= 1 && tryToCreateSomething) {
      return true;
    } else {
      return false;
    }
  };

  if (verifyIfAllIsCreated.createdUsers) {
    navigate("/users");
    setTimeout(() => {
      cancel();
    }, 1000);

    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }

  return (
    <div className="create-sites-container">
      {MenuCreateUsers(
        createUserSteps,
        t,
        setSteps,
        navigate,
        cancel,
        resetCreateUsersValues,
        multiLocationLoading
      )}
      <div className="steps-container-create-loc">
        <div className="step-title">{t("Create_site.config_users.step")}</div>
        <div>
          <div className="step-title-create">
            {t("Create_site.config_users.config")}
          </div>
          <div className="design-scope">
            {t("Create_site.config_users.config_scope")}
          </div>
          {managingError()}
          {managingShowErrors() ? managingErrorValidator() : undefined}
          <div className="create-site-form" style={{ background: "#fff" }}>
            <Box sx={{ height: 420, width: 1 }}>
              <ThemeProvider theme={themeInarix(locale)}>
                <DataGridPro
                  rows={rowsAlpha.length === 0 ? [] : rowsAlpha}
                  loading={multiLocationLoading}
                  columns={
                    rawColumns.length === 0
                      ? [
                          {
                            field: "id",
                            sortable: true,
                            width: 100,
                          },
                        ]
                      : rawColumns
                  }
                  onColumnOrderChange={() => {
                    setColumnIndex(apiRef.current.getAllColumns());
                  }}
                  onColumnWidthChange={() =>
                    setColumnIndex(apiRef.current.getAllColumns())
                  }
                  editMode="row"
                  rowModesModel={rowModesModel}
                  onRowModesModelChange={handleRowModesModelChange}
                  onRowEditStop={handleRowEditStop}
                  processRowUpdate={processRowUpdate}
                  pageSizeOptions={[25, 50, 100]}
                  slots={{
                    footer: editToolbar as any["footer"],
                  }}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 25 } },
                  }}
                  apiRef={apiRef}
                  rowHeight={70}
                />
              </ThemeProvider>
            </Box>
            <Button
              onClick={() => {
                if (totalErrors >= 1) {
                  tryToCreate(true);
                }
                if (totalErrors === 0) {
                  tryToCreate(false);
                  creatMultiUsers(userId as string, token, realmId);
                }
              }}
              sx={{ textTransform: "none", width: "79px", marginTop: "24px" }}
              variant="contained"
              disabled={multiLocationLoading}
            >
              {t("Create_site.config_users.create")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepConfigCreateUsersFromUsers;
